import { render, staticRenderFns } from "./ServiceComplaint.vue?vue&type=template&id=4831289f"
import script from "./ServiceComplaint.vue?vue&type=script&lang=js"
export * from "./ServiceComplaint.vue?vue&type=script&lang=js"
import style0 from "./ServiceComplaint.vue?vue&type=style&index=0&id=4831289f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports